import { useParams } from "react-router-dom";
import SolicitationTabs from "./components/SolicitationTabs";
import {Solicitation} from "../../types/solicitation/solicitationData";
import {useEffect, useState} from "react";
import {HttpSolicitation} from "../../http/solicitation/httpSolicitation";
import {LoaderBlockUI} from "../../components/loader";

const SolicitationSummaryWrapper = () => {
    const { id } = useParams();
    const [solicitation, setSolicitation] = useState<Solicitation>()
    const [loading, setLoading] = useState<boolean>(false)

    const idSolicitud = id ? parseInt(id) : undefined
    
    const getSolicitation = () => {
        if(idSolicitud) {
            setLoading(true)
            HttpSolicitation.getSolicitationById(idSolicitud).then((res) => {
                setSolicitation(res)
                setLoading(false)
            })
        }
    }
    
    useEffect(() => {
        getSolicitation()
    }, [idSolicitud])
    

    return (
        loading ? <LoaderBlockUI /> : solicitation ? <SolicitationTabs solicitud={solicitation} reload={getSolicitation}/>: <></>
    )
    
}

export default SolicitationSummaryWrapper;